/**
 * Эксперимент с поисковой строкой на выдаче.
 *
 * Намеренно объявлен константами, а не через `defineExperiment`: его хук `use()` вместе с группой
 * отправляет экспозицию, а нам она здесь не нужна. Экспозицию шлёт хост, который и решает,
 * показывать ли строку. Микрофронт же читает группу и на главной, где эксперимент ни при чём, —
 * экспозиция оттуда разбавляла бы выборку теми, кто до выдачи не дошёл.
 */
export const SEARCH_STRING_EXPERIMENT = 'aud_mobile_bx1170_search_string_and_ff';

/** Группа, в которой поисковая строка включена. */
export const SEARCH_STRING_EXPERIMENT_GROUP = 'B';

export const EXPERIMENTS: string[] = [SEARCH_STRING_EXPERIMENT];
